/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 11/4/25
 */

import React from 'react';
import WorkplanFormSchemas from '@/components/FormSchemas/WorkplanFormSchemas';
import { FormType } from '@/components/contexts/FormsContext/FormsProvider';
import BaseJsonForm from '@/components/WorkplanItemForm/BaseJsonForm';
import useWorkplanVersion from '@/components/contexts/VersionContext/useWorkplanVersion';

const StaticForm = ({ type }: { type: FormType }) => {
    const { workplanVersion } = useWorkplanVersion();

    return (
        <WorkplanFormSchemas
            type={type}
            render={({ schema, uischema }) => (
                <BaseJsonForm
                    schema={schema}
                    uischema={uischema}
                    initialData={{}}
                    config={{
                        readonly: true,
                        isAuthor: true,
                        isSubmitted: true,
                        hideRequiredAsterisk: true,
                        metadata: {
                            probationDetails: '',
                            teachingAllocation: workplanVersion?.teachingWorkloadPortion ?? 0,
                            researchAllocation: workplanVersion?.researchWorkloadPortion ?? 0,
                            serviceAllocation: workplanVersion?.serviceWorkloadPortion ?? 0,
                            fte: workplanVersion?.fte ?? 1,
                            gradeName: workplanVersion?.gradeName?.split(' ')?.[1] ?? '',
                        },
                        formChanges: {},
                        changed: false,
                    }}
                />
            )}
        />
    );
};

export default StaticForm;
